import React from 'react';
import { Text, View } from 'react-native';

const DateTimePicker = () => {
    return (<View style={{ flexWrap: "wrap", backgroundColor: '#d3d3d3', padding: 12.0 }}>
        <Text>
            Hi Tamil
        </Text>
    </View>);
};

export default DateTimePicker;

